<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="asegurados"
        :search="search"
        sort-by="calories"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Base Assa</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-row no-gutters>
              <v-col>
                <v-file-input
                  v-if="esAdministrador()"
                  label="Archivo Excel ASSA"
                  hide-details
                  @change="cargarExcel()"
                ></v-file-input>
              </v-col>
              <v-col>
                <v-file-input
                  v-if="esAdministrador()"
                  label="Archivo Excel a JSON"
                  hide-details
                  @change="excelToJSON()"
                ></v-file-input>
              </v-col>
              <v-col cols="4" class="ml-2">
                <v-text-field
                  class="text-xs-center"
                  v-model="search"
                  append-icon="search"
                  label="Busqueda"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>

            <v-btn
              v-if="esAdministrador()"
              class="ml-3"
              rounded
              color="primary"
              @click="dialogMessageTruncate = true"
              >Borrar Registros</v-btn
            >

            <v-dialog v-model="dialog" max-width="700px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="poliza"
                          label="POLIZA"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          v-model="nombre"
                          label="ASEGURADO"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="inicioVigencia"
                          label="INICIO VIGENCIA"
                          hint="Ejemplo: YYYY/MM/DD"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="finVigencia"
                          label="FIN VIGENCIA"
                          hint="Ejemplo: YYYY/MM/DD"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="marca"
                          label="MARCA"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="modelo"
                          label="MODELO"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="placa"
                          label="PLACA"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          type="number"
                          v-model="año"
                          label="AÑO"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="vin" label="VIN"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="motor"
                          label="MOTOR"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="color"
                          label="COLOR"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="dañosPropios"
                          label="DAÑOS PROPIOS"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="morosidad"
                          label="MOROSIDAD"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="nit" label="NIT"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="idepol"
                          label="IDEPOL"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="codigoProducto"
                          label="CODIGO PRODUCTO"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="8">
                        <v-text-field
                          v-model="agente"
                          label="AGENTE"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-show="valida">
                        <div
                          class="red--text"
                          v-for="v in validaMensaje"
                          :key="v"
                          v-text="v"
                        ></div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="cancel" @click="close()">CERRAR</v-btn>
                  <v-btn
                    v-if="esAdministrador()"
                    color="success"
                    @click="guardar()"
                    >GUARDAR</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="addModal" max-width="290px">
              <v-card>
                <v-card-title class="headline" v-if="addAccion == 1"
                  >¿Activar Item?</v-card-title
                >
                <v-card-title class="headline" v-if="addAccion == 2"
                  >Desactivar Item?</v-card-title
                >
                <v-card-text>
                  Estas a punto de
                  <span v-if="addAccion == 1">activar</span>
                  <span v-if="addAccion == 2">desactivar</span>
                  el cliente {{ addAsegurado }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="cancel" @click="ActivarDesactivarCerrar">
                    Cerrar
                  </v-btn>
                  <v-btn v-if="addAccion == 1" color="success" @click="activar">
                    Activar
                  </v-btn>
                  <v-btn
                    v-if="addAccion == 2"
                    color="warning"
                    @click="desactivar"
                  >
                    Desactivar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogMessageTruncate" max-width="500">
              <v-card>
                <v-card-text class="headline font-weight-bold pt-2"
                  >Esta a punto de eliminar la base de datos</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="grey"
                    dark
                    @click="dialogMessageTruncate = false"
                    >Cancelar</v-btn
                  >
                  <v-btn color="orange" dark @click="truncarBase()"
                    >Continuar</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
          <template v-if="item.condicion && esAdministrador()">
            <v-icon small @click="ActivarDesactivar(2, item)"> block </v-icon>
          </template>
          <template v-else-if="esAdministrador()">
            <v-icon small @click="ActivarDesactivar(1, item)"> check </v-icon>
          </template>
        </template>
        <template v-slot:[`item.condicion`]="{ item }">
          <v-chip :color="getColorCondicion(item.condicion)" dark>
            <div v-if="item.condicion"><span>Activo</span></div>
            <div v-else><span>Inactivo</span></div>
          </v-chip>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogProgress" max-width="250">
        <v-card>
          <v-row no-gutters justify="center">
            <v-col cols="8">
              <progress-bar class="mx-1" :options="options" :value="contador" />
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogProgressJSON" width="250">
        <v-card>
          <v-row no-gutters>
            <v-col cols="auto">
              <progress-bar
                class="mt-2"
                :options="optionsJSON"
                :value="contador"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-overlay v-model="overlay" z-index="1">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import XLSX from "xlsx";

const convertArrayToObject = (array = [], key) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
};

export default {
  data() {
    return {
      dialog: false,
      asegurados: [],
      headers: [
        { text: "Opciones", value: "action", sortable: true },
        { text: "Nombre", value: "nombre", sortable: true },
        { text: "Inicio Vigencia", value: "inicioVigencia", sortable: true },
        { text: "Fin Vigencia", value: "finVigencia", sortable: true },
        { text: "Placa", value: "placa", sortable: true },
        { text: "Marca", value: "marca", sortable: true },
        { text: "Modelo", value: "modelo", sortable: true },
        { text: "Color", value: "color" },
        { text: "Estatus", value: "condicion" },
      ],
      search: "",
      editedIndex: -1,
      idBaseAssa: "",
      poliza: "",
      nombre: "",
      placa: "",
      marca: "",
      modelo: "",
      año: 0,
      motor: "",
      vin: "",
      inicioVigencia: "",
      finVigencia: "",
      dañosPropios: "",
      morosidad: "",
      color: "",
      nit: "",
      idepol: "",
      codigoProducto: "",
      agente: "",
      condicion: false,
      ///////////////////////
      valida: 0,
      validaMensaje: [],
      addModal: 0,
      addAccion: 0,
      addAsegurado: "",
      addId: "",
      overlay: false,
      page: 1,
      file: "",
      dialogMessageTruncate: false,
      flag: 0,
      dialogProgress: false,
      dialogProgressJSON: false,
      arr: [],
      ///////////////////////
      polizaExcel: "",
      nombreExcel: "",
      placaExcel: "",
      marcaExcel: "",
      modeloExcel: "",
      añoExcel: 0,
      motorExcel: "",
      vinExcel: "",
      inicioVigenciaExcel: "",
      finVigenciaExcel: "",
      dañosPropiosExcel: "",
      morosidadExcel: "",
      colorExcel: "",
      nitExcel: "",
      idepolExcel: "",
      codigoProductoExcel: "",
      contador: 0,
      cantidadRegistros: 0,
      chatId: -1001607334169,
      token: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
      optionsJSON: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
          inverted: false,
        },
        layout: {
          height: 35,
          width: 250,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "line",
        },
      },
      options: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#2dbd2d",
          backgroundColor: "#333333",
          inverted: false,
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: "cylinder",
        },
      },
    };
  },
  components: {
    InfiniteLoading,
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo" : "Actualizar";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {
    excelToJSON() {
      this.dialogProgressJSON = true;
      var file = event.target.files ? event.target.files[0] : null;
      if (file != null) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          //console.log("DATA", data);
          this.generarJSON(data);
        };

        reader.readAsBinaryString(file);
      }
    },
    async generarJSON(data) {
      var i, json;
      var j = 0;
      this.contador = 0;
      for (i = 0; i < data.length; i++) {
        j = j + 1; //contador para el progress
        this.contador = parseInt(((j / data.length) * 100).toFixed(0));
        var placa = data[i]["placa"];
        var asegurado = data[i]["nombre"];
        var año = data[i]["año"];
        var marca = data[i]["marca"];
        var modelo = data[i]["modelo"];
        var color = data[i]["color"];
        var poliza = data[i]["poliza"];
        await this.arr.push({
          placa: placa,
          año: año,
          marca: marca,
          asegurado: asegurado,
          modelo: modelo,
          color: color,
          poliza: poliza,
        });
      }
      json = JSON.stringify(this.arr);
      var objectJson = convertArrayToObject(this.arr, "placa");
      this.saveFile(objectJson);
    },
    saveFile(arr) {
      const data = JSON.stringify(arr);
      const blob = new Blob([data], { type: "text/plain" });
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
      a.download = "dataBase.json";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
      e.initEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
    },
    esAdministrador() {
      if (this.$store.state.usuario.nombre == "administrador") {
        return true;
      } else {
        return false;
      }
    },
    truncarBase() {
      let me = this;
      me.overlay = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Assas/TrucarBaseAssa", configuracion)
        .then(function (response) {
          me.dialogMessageTruncate = false;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listar() {
      let me = this;
      me.overlay = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Assas/Listar", configuracion)
        .then(function (response) {
          me.asegurados = response.data;
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getColorCondicion(condicion) {
      if (condicion == true) {
        return "green";
      } else {
        return "red";
      }
    },
    editItem(item) {
      this.idBaseAssa = item.idBaseAssa;
      this.poliza = item.poliza;
      this.nombre = item.nombre;
      this.inicioVigencia = item.inicioVigencia;
      this.finVigencia = item.finVigencia;
      this.marca = item.marca;
      this.modelo = item.modelo;
      this.placa = item.placa;
      this.año = item.año;
      this.vin = item.vin;
      this.motor = item.motor;
      this.color = item.color;
      this.dañosPropios = item.dañosPropios;
      this.morosidad = item.morosidad;
      this.nit = item.nit;
      this.idepol = item.idepol;
      this.codigoProducto = item.codigoProducto;
      this.agente = item.agente;
      this.editedIndex = 1;
      this.dialog = true;
    },
    ActivarDesactivar(accion, item) {
      this.addModal = 1;
      this.addAsegurado = item.nombre;
      this.addId = item.idBaseAssa;
      if (accion == 1) {
        this.addAccion = 1;
      } else if (accion == 2) {
        this.addAccion = 2;
      } else {
        this.addModal = 0;
      }
    },
    ActivarDesactivarCerrar() {
      this.addModal = 0;
    },
    close() {
      this.dialog = false;
      this.limpiar();
    },
    limpiar() {
      this.idBaseAssa = "";
      this.poliza = "";
      this.nombre = "";
      this.inicioVigencia = "";
      this.finVigencia = "";
      this.marca = "";
      this.modelo = "";
      this.placa = "";
      this.año = "";
      this.vin = "";
      this.motor = "";
      this.color = "";
      this.dañosPropios = "";
      this.morosidad = "";
      this.nit = "";
      this.idepol = "";
      this.codigoProducto = "";
      this.agente = "";
      this.editedIndex = -1;
    },
    limpiarDatosExcel() {
      this.polizaExcel = "";
      this.nombreExcel = "";
      this.placaExcel = "";
      this.marcaExcel = "";
      this.modeloExcel = "";
      this.añoExcel = 0;
      this.motorExcel = "";
      this.vinExcel = "";
      this.inicioVigenciaExcel = "";
      this.finVigenciaExcel = "";
      this.dañosPropiosExcel = "";
      this.morosidadExcel = "";
      this.colorExcel = "";
      this.nitExcel = "";
      this.idepolExcel = "";
      this.codigoProductoExcel = "";
    },
    guardar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.editedIndex > -1) {
        //codigo para editar
        let me = this;
        axios
          .put(
            "api/Assas/Actualizar",
            {
              idBaseAssa: me.idBaseAssa,
              poliza: me.poliza,
              nombre: me.nombre,
              placa: me.placa,
              marca: me.marca,
              modelo: me.modelo,
              año: me.año,
              motor: me.motor,
              vin: me.vin,
              inicioVigencia: me.inicioVigencia,
              finVigencia: me.finVigencia,
              dañosPropios: me.dañosPropios,
              morosidad: me.morosidad,
              color: me.color,
              nit: me.nit,
              idepol: me.idepol,
              codigoProducto: me.codigoProducto,
            },
            configuracion
          )
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post(
            "api/Assas/Crear",
            {
              poliza: me.poliza,
              nombre: me.nombre,
              placa: me.placa,
              marca: me.marca,
              modelo: me.modelo,
              año: me.año,
              motor: me.motor,
              vin: me.vin,
              inicioVigencia: me.inicioVigencia,
              finVigencia: me.finVigencia,
              dañosPropios: me.dañosPropios,
              morosidad: me.morosidad,
              color: me.color,
              nit: me.nit,
              idepol: me.idepol,
              codigoProducto: me.codigoProducto,
            },
            configuracion
          )
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    activar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/Assas/Activar/" + this.addId, {}, configuracion)
        .then(function (response) {
          me.addModal = 0;
          me.addAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    desactivar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/Assas/Desactivar/" + this.addId, {}, configuracion)
        .then(function (response) {
          me.addModal = 0;
          me.addAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //Metodo para cargar excel y agregar registros
    cargarExcel() {
      this.dialogProgress = true;
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);

          this.agregarCliente(data);
          this.cantidadRegistros = data.length;
        };

        reader.readAsBinaryString(this.file);
      }
    },
    async agregarCliente(data) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      var i;
      var j = 0;
      me.contador = 0;
      for (i = 0; i < data.length; i++) {
        j = j + 1; //contador para el progress
        me.contador = parseInt(((j / data.length) * 100).toFixed(0));
        me.polizaExcel = data[i]["poliza"];
        me.nombreExcel = data[i]["nombre"];
        me.placaExcel = data[i]["placa"];
        me.marcaExcel = data[i]["marca"];
        me.modeloExcel = data[i]["modelo"];
        me.añoExcel = data[i]["año"];
        me.motorExcel = data[i]["motor"];
        me.vinExcel = data[i]["vin"];
        me.inicioVigenciaExcel = data[i]["inicioVigencia"];
        me.finVigenciaExcel = data[i]["finVigencia"];
        me.dañosPropiosExcel = data[i]["dañosPropios"];
        me.morosidadExcel = data[i]["morosidad"];
        me.colorExcel = data[i]["color"];
        me.nitExcel = data[i]["nit"];
        me.idepolExcel = data[i]["idepol"];
        me.codigoProductoExcel = data[i]["codigoProducto"];
        me.agente = data[i]["agente"];
        await axios
          .post(
            "api/Assas/Crear",
            {
              poliza: me.polizaExcel,
              nombre: me.nombreExcel,
              placa: me.placaExcel,
              marca: me.marcaExcel,
              modelo: me.modeloExcel,
              año: me.añoExcel,
              motor: me.motorExcel,
              vin: me.vinExcel,
              inicioVigencia: me.inicioVigenciaExcel,
              finVigencia: me.finVigenciaExcel,
              dañosPropios: me.dañosPropiosExcel,
              morosidad: me.morosidadExcel,
              color: me.colorExcel,
              nit: me.nitExcel,
              idepol: me.idepolExcel,
              codigoProducto: me.codigoProductoExcel,
              agente: me.agente
            },
            configuracion
          )
          .then(function (response) {
            me.limpiarDatosExcel();
            if (j == data.length) {
              me.dialogProgress = false;
              me.listar();
              me.notificacionTelegram();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    async notificacionTelegram() {
      var today = new Date();
      var fechaActual =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();

      var cuenta = "ASSA Compañía de seguros";
      var cantRegistros = this.cantidadRegistros;
      var mensaje =
        "Se notifica sobre la siguiente actualización de la base de datos de la cuenta: " +
        cuenta +
        "%0A" +
        "Fecha de la actualización: " +
        fechaActual +
        "%0A" +
        "Cantidad de registros que fueron agregados: " +
        cantRegistros;

      await axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/sendMessage?chat_id=" +
            this.chatId +
            "&text=" +
            mensaje
        )
        .then((response) => {
          console.log("Mensaje enviado", response.status);
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
  },
};
</script>
